import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import {  CardActionArea } from "@mui/material";
import bgAvatar from "../../../assets/Abstrack.png";
import {} from "./CardStyle.css";
function OneCard(props) {
  return (
    <>
      <Card sx={{ maxWidth: 200 }} className="mx-3 mb-3">
        <CardActionArea>
          <div className="row d-flex justify-content-center">
            <div className="bgstyle my-4 d-flex justify-content-center align-items-center position-relative">
              <img
                src={bgAvatar}
                alt=""
                srcset=""
                className="position-absolute imgStyle"
              />
              <Avatar
                className="position-aboslute"
                src={props.imageAvatar}
                sx={{ width: 100, height: 100 }}
                alt="Remy Sharp"
              />
            </div>
          </div>
          <div className="mb-3">
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              className="row d-flex justify-content-center"
            >
              {props.name}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              className="row d-flex justify-content-center"
            >
              {props.discription}
            </Typography>
          </div>
        </CardActionArea>
      </Card>
    </>
  );
}

export default OneCard;
